<div class="row">
	<div class="col-sm-4"><label>Imię: </label>{{ lead.firstName }}</div>
	<div class="col-sm-4"><label>Miasto: </label>{{ lead.city }}</div>
	<div class="col-sm-4"><label>Rodzaj: </label>{{ lead.type }}</div>
	<div class="col-sm-4"><label>Nazwisko: </label>{{ lead.lastName }}</div>
	<div class="col-sm-4"><label>Telefon: </label>{{ lead.phone1 }}</div>
	<div class="col-sm-4"><label>Żródło: </label>{{ sourceName }}</div>
	<div class="col-sm-4">
		<div *ngIf="details"><label>Dane żródła: </label>{{ details }}</div>
	</div>
	<div class="col-sm-4"><label>E-mail: </label>{{ lead.email1 }}</div>
	<div class="col-sm-4"><label>Opiekun: </label>{{ ownerName }}</div>
</div>
